import React, { useEffect, useRef } from "react";
import * as R from "ramda";
import Toolbar from "./Toolbar";
import SessionList from "./SessionList";
import { connect } from "react-redux";
import { Div } from "components/Base";

import styles from "./styles.scss";

import { actions as wrapperActions } from "Portal/NewPortal/Wrapper/model";

import { noop } from "utils/General";

import {
  getters as SessionModalGetters,
  actions as SessionModalActions
} from "EventLight/Sessions/AddSessionModal/model";

import AddSessionModal from "EventLight/Sessions/AddSessionModal/View";

import { getSessions } from "Portal/NewPortal/PortalHome/selectors";
import { actions } from "../model";

const decorate = R.compose(
  connect(
    (state, props) => ({
      showSessionModal: SessionModalGetters.showSessionModal(state, props),
      sessions: getSessions(state)
    }),
    {
      setFlyOverWidth: wrapperActions.setFlyOverWidth,
      hideShowSessionModal: () =>
        SessionModalActions.setShowSessionModal(false),
      init: actions.init
    }
  )
);

// this need to be calculated after open the flyover
// to gives the oportunity to the client to scroll and select the session that he needs

const Layout = ({
  setFlyOverWidth = noop,
  showSessionModal = false,
  hideShowSessionModal = noop,
  init = noop,
  sessions = []
}) => {
  const containerDivRef = useRef(null);
  const subRightContainerDivRef = useRef(null);
  useEffect(() => {
    const calculateWidth = () => {
      let x,
        y = 0;
      if (containerDivRef.current && subRightContainerDivRef.current) {
        const firstDivWidth = containerDivRef.current.offsetWidth;
        const subRightDivWidth = subRightContainerDivRef.current.offsetWidth;
        const screenWidth = window.innerWidth;
        if (screenWidth < 1200) {
          //mobile devices
          setFlyOverWidth(screenWidth);
        } else if (screenWidth > firstDivWidth) {
          x = (screenWidth - firstDivWidth) / 2;
          y = firstDivWidth - subRightDivWidth;
          setFlyOverWidth(x + y - 5);
        }
      }
    };

    // Call calculateWidth initially
    calculateWidth();

    // Add event listener to recalculate on window resize
    window.addEventListener("resize", calculateWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateWidth);
    };
  }, []);

  useEffect(() => {
    init({ sessions });
  }, [sessions]);
  return (
    <div className={styles.sessionSectionContainer} ref={containerDivRef}>
      <div
        className={styles.sessionSectionLeftContainer}
        ref={subRightContainerDivRef}
      >
        <Toolbar />
        <SessionList />
      </div>
      <Div className={styles.sessionSectionRightContainer}></Div>
      {showSessionModal && <AddSessionModal hideModal={hideShowSessionModal} />}
    </div>
  );
};

export default decorate(Layout);
